var map = {
	"./choisir-emballages-alimentaires.json": 4352,
	"./dark-kitchens-bonnes-pratiques.json": 5683,
	"./kebab-pro-2026.json": 1440,
	"./rentabilite-restauration-rapide.json": 6949,
	"./tendances-snacking-2026.json": 3737,
	"./vitesse-cuisine-fast-food.json": 9112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8069;